// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1FVfm","sortsContainer":"styles_sortsContainer__2hWHw"};